<template>
  <div>
    <Row type="flex" justify="start" ref="cardgroup" class="cardgroup">
      <Col v-for="(item,index) in orgList" :key="index" :style="{'margin-left':marginLeft}">
        <Card class="icard" :padding="0">
          <div
            class="card-wrapper"
            @click="cardClick(item)"
            @mouseover="cardHover(index)"
            @mouseout="cardOut(index)"
          >
            <!-- 右上角叉叉 -->
            <div
              class="iconfont icon-chushaixuanxiang icon-cha"
              v-show="item.showCha"
              @click.stop="clickCha(item,index)"
            ></div>
            <!--卡片内容-->
            <div class="top box">
              <div class="name">{{item.name}}</div>
              <div class="iconfont icon-daV" :style="{color:item.dianliang?'#ff9901':'#c6c6c6'}"></div>
            </div>
            <div class="bottom box v-center">
              <div class="box v-center">
                <div class="iconfont icon-chengyuan"></div>
                <div>
                  <div class="item">
                    成员
                    <div v-if="item.new" :class="[item.new.toString().length == 1?'new-circle':'new']">{{item.new}}</div>
                  </div>
                  <div class="number">{{item.chengyuan}}人</div>
                </div>
              </div>
              <div class="box v-center">
                <div class="iconfont icon-huodong"></div>
                <div>
                  <div class="item">活动</div>
                  <div class="number">{{item.huodong}}</div>
                </div>
              </div>
              <div class="box v-center">
                <div class="iconfont icon-paiming1"></div>
                <div>
                  <div class="item">排名</div>
                  <div class="number">{{item.paiming}}/{{item.total}}</div>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
    <Modal v-model="isShowDelete" title="删除" width="660px" @on-ok="onDelete">
      <div>确定删除该组织吗？</div>
    </Modal>
  </div>
</template>

<script>
  export default {
    name: 'organizeCard',
    props: {
      orgList:{
        type:Array,
        default:function () {
          return []
        }
      }
    },
    data() {
      return {
        cardItemWidth: 480, // 设为0 可动态获取 宽度
        marginLeft: "",
        isShowDelete: false,
        delId:''
      };
    },
    watch: {
      orgList: {
        handler:function(newVal,oldVal){
          //  没有初始化时执行
          if (!this.cardItemWidth) {
            // 有数据时执行
            if (this.$refs.cardgroup.$children.length > 0) {
              this.cardItemWidth = this.$refs.cardgroup.$children[0].$el.clientWidth;
              this.getMargin();
            }
          }
        },
        deep:true,
        immediate:true
      }
    },
    methods:{
      /* 点击 */
      cardClick(item) {
        this.$emit("cardClick", item);
      },
      cardHover(index) {
        this.orgList[index].showCha = true;
      },
      cardOut(index) {
        this.orgList[index].showCha = false;
      },
      clickCha(item, index) {
        this.delId = item.id
        this.isShowDelete = true
      },
      onDelete () {
        var url = this.urlobj.delOrg(this.delId)
        this.$delete(url).then(res => {
          this.$Message.success('删除成功')
          this.$emit('init')
        })
      },
      getMargin() {
        this.$nextTick()
          .then(() => {
            if (this.$refs.cardgroup) {
              let boxWidth = this.$refs.cardgroup.$el.clientWidth;
              let count = Math.floor(boxWidth / this.cardItemWidth) + 1;
              let rest = boxWidth % this.cardItemWidth;
              this.marginLeft = rest / count + "px";
            }
          })
          .catch(e => console.log(e));
      }
    },
    mounted() {
      this.getMargin();
      window.onresize = this.getMargin;
    }
  }
</script>

<style scoped lang="less">
.card-wrapper {
  position: relative;
  width: 480px;
  height: 250px;
  border-radius: 6px;
  .icon-cha {
    position: absolute;
    right: 10px;
    top: 10px;
    color: #cdcdcd;
    font-size: 20px;
  }
  .top{
    height: 62%;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #f1f1f1;
    padding: 0 30px;
    .name{
      font-size: 24px;
      color:#333;
    }
    .iconfont{
      margin-left: 10px;
      font-size: 28px;
      padding-top: 3px;
    }
  }
  .bottom{
    height: 38%;
    justify-content: space-around;
    color:#333;
    line-height: 1;
    .iconfont{
      color:#ff7666;
      font-size: 26px;
      margin-right: 15px;
    }
    .item{
      color:#666;
      margin-bottom: 13px;
      position: relative;
      font-size: 15px;
      .new-circle{
        height: 15px;
        width: 15px;
        background: #d22b2b;
        color: #fff;
        border-radius: 50%;
        line-height: 15px;
        text-align: center;
        position: absolute;
        top: -10px;
        left:90%;
        font-size: 12px;
      }
      .new{
        height: 15px;
        min-width: 15px;
        background: #d22b2b;
        color: #fff;
        border-radius: 15px;
        line-height: 15px;
        text-align: center;
        position: absolute;
        top: -10px;
        left:90%;
        font-size: 12px;
        padding: 0 5px;
      }
    }
    .number{
      font-size: 16px;
      font-weight: 600;
    }
  }
}
.v-center{
  align-items: center;
}
.icard {
  margin-bottom: 30px;
  border-radius: 6px;
}
</style>
